module.exports = {
  label: {
    registerText: 'You are not a registered doctor, Please contact our team to get you started',
    contactDetail: 'Contact Details',
    buttons: {
      backLogin: 'Back to Login'
    }
  }
}